import React from "react";
import PropTypes from "prop-types";

class EditPostForm extends React.Component {
  static propTypes = {
    post: PropTypes.shape({
      image: PropTypes.string.isRequired,
      place: PropTypes.string.isRequired,
      desc: PropTypes.string.isRequired,
      year: PropTypes.number.isRequired
    }),
    updatePost: PropTypes.func.isRequired,
    index: PropTypes.string.isRequired
  };
  
  handleChange = event => {
    // Update that post
    // 1. Take a copy of the current post
    const updatedPost = {
      ...this.props.post,
      [event.currentTarget.name]: event.currentTarget.value
    };
    // 2. update that post
    this.props.updatePost(this.props.index, updatedPost);
  };

  render () {
    return (
      <div className="post-edit" onSubmit={this.createPost}>
        <input name="place" onChange={this.handleChange} value={this.props.post.place} type="text" />
        <input name="year" onChange={this.handleChange} value={this.props.post.year} type="text" />
        <textarea name="desc" onChange={this.handleChange} value={this.props.post.desc}></textarea>
        <input name="image" onChange={this.handleChange} value={this.props.post.image} type="text" />
        <button type="submit" onClick={() => this.props.deletePost(this.props.index)}>Remove Post</button>
      </div>
    );
  }
}

export default EditPostForm;